export class InfoPageEvents {
    public static readonly OPENED: string = 'INFO_PAGE_OPENED';
    public static readonly CLOSED: string = 'INFO_PAGE_CLOSED';
}